@if (flatItem) {
  <div class="current-mix">
    <pv2-mix-details [flatItem]="flatItem" [displayImage]="false" displayName="inline"
                     [displayPlayButton]="false" [displayDescription]="false">
    </pv2-mix-details>
  </div>
}
